import { FormControlData, FormControlValue, CreateFormControlProps, ICollectionInputFile } from "../model";
import { createFormControl } from "solid-forms";
import { Label, InputFile, Error } from "../views";

export function createInputFile<D extends FormControlData = FormControlData>(
  ...args: CreateFormControlProps<FileList, D>
): ICollectionInputFile<D> {
  const control = createFormControl<FileList, D>(...args);
  const name = String(control.id);
  return {
    control,
    name,
    Label: (props) => <Label control={control} for={name} {...props} />,
    Error: (props) => <Error control={control} {...props} />,
    InputFile: (props) => <InputFile control={control} name={name} {...props} />,
  };
}
